module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((this.content), function(x) {
    return _c('el-card', {
      key: x.id,
      staticClass: "box-card-component",
      style: (_vm.bodystyle(x.hotnews))
    }, [_c('div', {
      staticClass: "box-card-header",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h1', [(x.hotnews) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("HOT NEWS: ")]) : _vm._e(), _c('span', {
      domProps: {
        "innerHTML": _vm._s(x.newstitle)
      }
    })])]), _vm._v(" "), _c('div', [(x.newsimage != '') ? _c('img', {
      staticStyle: {
        "float": "right",
        "width": "250px",
        "margin-bottom": "20px"
      },
      attrs: {
        "src": x.newsimage
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(x.newstext)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "break": "both",
        "font-size": "10px",
        "float": "right",
        "margin-bottom": "5px",
        "clear": "both"
      }
    }, [_vm._v("Created: " + _vm._s(x.newscreated) + " By: " + _vm._s(x.newsby))])])])
  }), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " items found")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f792aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/xshownews.vue
// module id = 637
// module chunks = 1